import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./ViewPage.css";

const WorkAllotmentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [allotment, setAllotment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchCustomerDetails();
    }
  }, [id]);

  const fetchCustomerDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post("/work_allotment_detail.php", { id });
      
      if (response.data.head.code === 200) {
        const allotDetail = response.data.body;
        const transformedCustomer = {
          id: allotDetail.id,
          worker_id: allotDetail.worker_id,
          worker_name: allotDetail.worker_name,
          allot_date: allotDetail.allot_date,
          raw_pid: allotDetail.raw_pid,
          raw_name: allotDetail.raw_name,
          finished_name: allotDetail.finished_name,
          finished_pid: allotDetail.finished_pid,
          allot_qty: allotDetail.allot_qty,
          return_qty: allotDetail.return_qty,
          balance_qty: allotDetail.balance_qty,
          amount_per_kg: allotDetail.amount_per_kg,
          amount_total_kg: allotDetail.amount_total_kg,
          note: allotDetail.note
        };
        setAllotment(transformedCustomer);
      } else {
        setError(response.data.head.msg || "Customer not found");
      }
    } catch (err) {
      console.error("Error fetching customer details:", err);
      setError("Failed to load customer details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    fetchCustomerDetails();
  };

  if (loading) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Customer Details</h2>
        <Row>
          <Col>
            <div className="text-center py-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p className="mt-3">Loading customer details...</p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (error || !allotment) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Allotment Details</h2>
        <Row>
          <Col>
            <div className="not-found-box">
              <p className="mb-3">{error || "allotment not found."}</p>
              <div className="d-flex justify-content-center gap-3">
                <Button variant="secondary" onClick={() => navigate(-1)}>
                  Back
                </Button>
                <Button variant="primary" onClick={handleRetry}>
                  Retry
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">Allotment Details</h2>
       
      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          <div className="customer-details-table-wrapper">
            <table className="customer-view-table" role="table" aria-label={`Details for ${allotment.worker_name}`}>
              <tbody>
                <tr>
                  <td className="field-cell">Worker Name</td>
                  <td className="value-cell">{allotment.worker_name}</td>
                </tr>

                <tr>
                  <td className="field-cell">Alloted Date</td>
                  <td className="value-cell">{allotment.allot_date || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Raw Product</td>
                  <td className="value-cell">{allotment.raw_name || "-"}</td>
                </tr>

                {/* <tr>
                  <td className="field-cell">Return Product</td>
                  <td className="value-cell">{allotment.finished_name || "-"}</td>
                </tr> */}

                <tr>
                  <td className="field-cell">Alloted Quantity</td>
                  <td className="value-cell">{allotment.allot_qty || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Returned Quantity</td>
                  <td className="value-cell">{allotment.return_qty || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Balance Quantity</td>
                  <td className="value-cell">{allotment.balance_qty || "-"}</td>
                </tr>

                {/* <tr>
                  <td className="field-cell">Amount per KG</td>
                  <td className="value-cell">{allotment.amount_per_kg || "-"}</td>
                </tr> */}

                <tr>
                  <td className="field-cell">Total Amount</td>
                  <td className="value-cell">{allotment.amount_total_kg || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Note</td>
                  <td className="value-cell">{allotment.note || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default WorkAllotmentView;